import React from 'react';
import HeaderComponent from "../../components/header/header.component";
import Image2Paragraphs from "../../components/image-with-paragraphs/image-with-paragraphs.component";
import CTAComponent from "../../components/call-to-action/cta-footer.component";
import TREATMENT_OPTIONS_DATA from "./treatment-options.data";

import ctaImage from '../../img/Cancer-Care-Images/CTA_Updated.png';
import heroImage from '../../img/Cancer-Care-Images/treatment-hero.png';
import ButtonsDirectoryComponent from "../../components/buttons-directory/buttons-directory.component";
import {Helmet} from "react-helmet";
import {hideMask} from "../../components/navigation/navigation.component";

class TreatmentOptionsPage extends React.Component {
    pageTitle = "Treatment Options";
    state = TREATMENT_OPTIONS_DATA;
    render() {
        return (
            <div>
                <Helmet>
                    <title>{this.pageTitle} | Optum Care Cancer Care</title>
                </Helmet>
                <main className='page-body' onClick={hideMask}>
                    <HeaderComponent imageUrl={heroImage} title={this.pageTitle} />
                    <div className='row justify-content-around'>
                        <div className="col-md-8 col-sm-12">
                            <p className="text-centered">
                            We offer a wide variety of treatments for most cancer types. Your oncologist will discuss your options so you can decide what works best for you.
                            </p>
                        </div>
                    </div>
                    <ButtonsDirectoryComponent buttons={this.state.buttons}/>
                    {
                        this.state.sections.map(({id, ...otherSectionProps}) => (
                            <Image2Paragraphs key={id} {...otherSectionProps} />
                        ))
                    }
                    <div className="cta-container">
                            <CTAComponent
                                imageUrl={ctaImage}
                                htmlCopy={this.state.ctaInfo.htmlCopy}
                            />
                    </div>
                </main>
                
            </div>
        );
    }
}

export default TreatmentOptionsPage;